
import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import CustomerGroup from '@/mixins/CustomerGroup';
import { mixins } from 'vue-class-component';
import { debounce } from '@/util/helper';

interface Selection {
  published?: boolean;
  verified?: boolean;
  sync?: boolean;
  deletedAt?: boolean;
  isServiceActivated?: boolean;
  deliveryEnabled?: boolean;
  customerGroup?: CustomerGroup;
}

@Component
export default class VenueFilter extends mixins(CustomerGroup) {
  public search: string = '';
  public published: boolean | null = null;
  public verified: boolean | null = null;
  public sync: boolean | null = null;
  public customerGroup: string | null = null;
  public isServiceActivated: boolean | null = null;
  public deliveryEnabled: boolean | null = null;
  public deletedAt: boolean = false;

  public created() {
    this.search = (this.$route.query.search as string) || '';
  }

  get selection() {
    const selection: Selection = {};

    if (this.published !== null) {
      selection.published = this.published;
    }
    if (this.verified !== null) {
      selection.verified = this.verified;
    }
    if (this.sync !== null) {
      selection.sync = this.sync;
    }
    if (this.customerGroup !== null) {
      selection.customerGroup = this.customerGroup as unknown as CustomerGroup;
    }
    if (this.isServiceActivated !== null) {
      selection.isServiceActivated = this.isServiceActivated;
    }
    if (this.deliveryEnabled !== null) {
      selection.deliveryEnabled = this.deliveryEnabled;
    }
    if (this.deletedAt) {
      selection.deletedAt = true;
    }

    return selection;
  }

  get publishedStatus() {
    return [
      { text: this.$t('common.noSelection'), value: null },
      { text: this.$t('venue.filter.published'), value: true },
      { text: this.$t('venue.filter.unpublished'), value: false },
    ];
  }

  get syncStatus() {
    return [
      { text: this.$t('common.noSelection'), value: null },
      { text: this.$t('venue.filter.sync'), value: true },
      { text: this.$t('venue.filter.idle'), value: false },
    ];
  }

  get verifiedStatus() {
    return [
      { text: this.$t('common.noSelection'), value: null },
      { text: this.$t('venue.filter.verified'), value: true },
      { text: this.$t('venue.filter.unverified'), value: false },
    ];
  }

  get isServiceActivatedStatus() {
    return [
      { text: this.$t('common.noSelection'), value: null },
      { text: this.$t('venue.filter.activated'), value: true },
      { text: this.$t('venue.filter.notActivated'), value: false },
    ];
  }

  get deliveryEnabledStatus() {
    return [
      { text: this.$t('common.noSelection'), value: null },
      { text: this.$t('venue.filter.enabled'), value: true },
      { text: this.$t('venue.filter.notEnabled'), value: false },
    ];
  }

  public onSearch() {
    this.$router.replace({ query: { ...this.$route.query, search: this.search } }).catch(() => {});
    this.$emit('change', { ...this.selection, search: this.search });
  }

  @Watch('selection')
  public onChange() {
    const self = this;
    debounce(() => {
      this.$router.replace({ query: { ...this.$route.query, search: this.search } }).catch(() => {});
      self.$emit('change', { ...self.selection, search: self.search });
    }, 500);
  }
}
